const useOnPremiseTypes = () => {
  const GET_EXPIRED_INFO = 'ON_PREMISE::GET_EXPIRED_INFO'
  
  return {
    GET_EXPIRED_INFO
  }
}

export default useOnPremiseTypes